import { isNumber } from 'util';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_14 implements Validator {

    public static id = 'CTRL_14';
    private message = 'error.ctr_14';


    public LOG: LogService = new LogService(CTRL_14);

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_14.id + '_');


        if (rgs.length > 0) {
            for (const rg of rgs) {
                const ctrl = form.controls[rg];
                const firstWithStepId = map.get(ctrl.value.rgCtrls.nbMois);
                const firstCtrl = form.controls[firstWithStepId];
                if (typeof firstCtrl.value !== 'number') {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }
}
